/*
  Desktop facet sidebar: keep it its own scroll container sized to the space
  below its current top, at every scroll position (owner, Jam c53a3790).

  The sidebar is sticky under the header, but on a collection or search page it
  sits below a tall hero banner, so at the top of the page its box started far
  down the viewport (measured ~657px on the Exhaust page) and ran well past the
  fold. Internal scrolling could not bring the lower filters (Price) on screen,
  because the bottom of the box was itself below the fold: only scrolling the
  whole page, which sticks the sidebar under the header, revealed them. A fixed
  CSS max-height cannot know the hero pushed the sidebar down.

  This measures the real gap between the sidebar's top and the viewport bottom
  on every scroll and resize, and caps the sidebar to it, so the box always fits
  the visible area and the entire filter list (through Price) is reachable by
  scrolling the sidebar itself. As the page scrolls and the sidebar rises to
  stick under the header, the cap grows to the full height. The CSS max-height
  stays as the no-JS fallback. Desktop only: below xl the filters are a drawer.
*/
(function () {
  var SELECTOR = '#FacetFiltersContainer .sticky-element';
  var MIN_HEIGHT = 200; // never collapse to an unusable sliver
  var BOTTOM_GAP = 16; // breathing room above the viewport bottom
  var desktop = window.matchMedia('(min-width: 1280px)');
  var ticking = false;

  function apply() {
    ticking = false;
    var el = document.querySelector(SELECTOR);
    if (!el) return;
    if (!desktop.matches) {
      el.style.removeProperty('max-height');
      return;
    }
    var top = el.getBoundingClientRect().top;
    if (top < 0) top = 0;
    var h = window.innerHeight - top - BOTTOM_GAP;
    if (h < MIN_HEIGHT) h = MIN_HEIGHT;
    el.style.maxHeight = h + 'px';
  }

  function schedule() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(apply);
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  if (desktop.addEventListener) {
    desktop.addEventListener('change', apply);
  }

  // facets.js replaces the sidebar markup after a filter change, which drops the
  // inline cap and changes the content height; recompute when that happens.
  var host = document.getElementById('FacetFiltersContainer');
  if (host && window.MutationObserver) {
    new MutationObserver(schedule).observe(host, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
